import { createSelector } from 'reselect';

import { sortByOrderNumber, getSorterByField } from './../orderSorters';
import { getOrderIdsWithUnreadMessages } from './../notification/selectors';

const stable = require('stable');

const getOrderList = state => state.ordersProgress.numbers.map(number => state.orders[number]);
const getSorting = state => state.ordersProgress.sorting;

export const getOrdersProgressSorted = createSelector(
    [getSorting, getOrderIdsWithUnreadMessages, getOrderList],
    ({ field, isAsc }, unreadOrderIds, orderList) => {
        const ordersSortedByNumber = stable(orderList, sortByOrderNumber);
        const sorter = getSorterByField(field, isAsc, unreadOrderIds);
        return stable(ordersSortedByNumber, sorter);
    }
);



// WEBPACK FOOTER //
// ./src/store/ordersProgress/selectors.js